import { render } from "./TableUsers.vue?vue&type=template&id=43d5e630&scoped=true"
import script from "./TableUsers.vue?vue&type=script&lang=js"
export * from "./TableUsers.vue?vue&type=script&lang=js"

import "./TableUsers.vue?vue&type=style&index=0&id=43d5e630&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d5e630"]])

export default __exports__